<!-- NO trigger button here; parent opens via #modal.open() -->
<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit profile</h2>
    </div>
  </div>
  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'First Name'"
          [placeholder]="'First Name'"
          [type]="'text'"
          [(value)]="user.first_name"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Last Name'"
          [placeholder]="'Last Name'"
          [type]="'text'"
          [(value)]="user.last_name"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Email'"
          [placeholder]="'Email'"
          [type]="'email'"
          [(value)]="user.email"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Phone'"
          [placeholder]="'Phone'"
          [type]="'tel'"
          [(value)]="user.phone"
        />
      </div>
    </div>
    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-6">
        <app-input-component
          [label]="'Date of birth'"
          [placeholder]="'Date of birth'"
          [type]="'date'"
          [(value)]="user.date_of_birth"
        />
      </div>
      <div class="col-lg-6 col-6">
        <app-input-component
          [label]="'Riding Club'"
          [placeholder]="'Riding Club'"
          [type]="'text'"
          [(value)]="user.riding_club"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Country'"
          [placeholder]="'Country'"
          [type]="'text'"
          [(value)]="user.country"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Address'"
          [placeholder]="'Address'"
          [type]="'text'"
          [(value)]="user.address"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'State'"
          [placeholder]="'State'"
          [type]="'text'"
          [(value)]="user.state"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'City'"
          [placeholder]="'City'"
          [type]="'text'"
          [(value)]="user.city"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Postal code'"
          [placeholder]="'Postal code'"
          [type]="'number'"
          [(value)]="user.zip_code"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="profileImage = $event[0]"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-button
      [label]="'Save'"
      [variant]="'primary'"
      (clicked)="saveProfile()"
    />
  </div>
</div>

